import { render, staticRenderFns } from "./ProductDimensionEditorControl.vue?vue&type=template&id=3c2fc900&scoped=true"
import script from "./ProductDimensionEditorControl.vue?vue&type=script&lang=js"
export * from "./ProductDimensionEditorControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2fc900",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c2fc900')) {
      api.createRecord('3c2fc900', component.options)
    } else {
      api.reload('3c2fc900', component.options)
    }
    module.hot.accept("./ProductDimensionEditorControl.vue?vue&type=template&id=3c2fc900&scoped=true", function () {
      api.rerender('3c2fc900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/ProductDimensionEditorControl.vue"
export default component.exports